import CitationModal from "./CitationModal";
import CitationBottomSheet from "./CitationBottomSheet";
import useAppModernisation from "../../hooks/useAppModernisation";
import useScreenSize from "../../hooks/useScreenSize";

const ResponsiveCitationView = (props) => {
  const { isAppMode } = useAppModernisation();
  const { isDesktop, isTabletSize } = useScreenSize();

  // Use bottom sheet for:
  // 1. PWA mode (always)
  // 2. Mobile screens (width < 768px)
  // Use modal for tablet and desktop screens in web mode
  if (isAppMode || (!isDesktop && !isTabletSize)) {
    return <CitationBottomSheet {...props} />;
  }

  return <CitationModal {...props} />;
};

export default ResponsiveCitationView;
